import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

const CardItems = (props) => {
  const [displayText, setDisplayText] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const text = props.CardText;
    const maxLength = 170; // Maximum number of characters to display before truncating
    if (text.length > maxLength) {
      setDisplayText(text.substring(0, maxLength) + '...');
    } else {
      setDisplayText(text);
    }
  }, [props.CardText]);

  const handleNavigate = (id) => {
    navigate('/experience-view', {
      state: {
        data: {
          id: id,
        },
      },
    });
  };
  return (
    <>
      <div className="card mb-0">
        <img
          src={props.ImagesCard}
          alt="event-1"
          className="img-fluid img-card-shot"
        />
        <div className="card-body">
          <h4 className="card-heading pb-3">{props.CardHeading}</h4>
          {/* <p className="card-titles">{props.DateCard}</p> */}
          {/* <a href={props.HrefLink}></a> */}
          <div className="">
            <p
              className="card-text mb-0 pb-2 d-flex align-items-center gap-2"
              style={{ color: 'rgba(0, 0, 0, 0.6)' }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="#00000099"
                version="1.1"
                id="Capa_1"
                width="17px"
                height="17px"
                viewBox="0 0 395.71 395.71"
                xmlSpace="preserve"
              >
                <g>
                  <path d="M197.849,0C122.131,0,60.531,61.609,60.531,137.329c0,72.887,124.591,243.177,129.896,250.388l4.951,6.738   c0.579,0.792,1.501,1.255,2.471,1.255c0.985,0,1.901-0.463,2.486-1.255l4.948-6.738c5.308-7.211,129.896-177.501,129.896-250.388   C335.179,61.609,273.569,0,197.849,0z M197.849,88.138c27.13,0,49.191,22.062,49.191,49.191c0,27.115-22.062,49.191-49.191,49.191   c-27.114,0-49.191-22.076-49.191-49.191C148.658,110.2,170.734,88.138,197.849,88.138z" />
                </g>
              </svg>
              Wellness Center, Downtown
            </p>
            <p
              className="card-text mb-0 pb-2 d-flex align-items-center gap-2"
              style={{ color: 'rgba(0, 0, 0, 0.6)' }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17px"
                height="17px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M12 7V12L10.5 14.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                  stroke="#00000099"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              March 15, 2025, 7:00 PM
            </p>
            <p
              className="card-text mb-0  d-flex align-items-center gap-2"
              style={{ color: 'rgba(0, 0, 0, 0.8)' }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17px"
                height="17px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="#00000099"
                  strokeWidth="1.5"
                />
                <path
                  d="M12 6V18"
                  stroke="#00000099"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <path
                  d="M15 9.5C15 8.11929 13.6569 7 12 7C10.3431 7 9 8.11929 9 9.5C9 10.8807 10.3431 12 12 12C13.6569 12 15 13.1193 15 14.5C15 15.8807 13.6569 17 12 17C10.3431 17 9 15.8807 9 14.5"
                  stroke="#00000099"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
              </svg>
              20.99 - 39.99
            </p>
          </div>
          {/* <hr /> */}
          <p
            className="card-text mb-0 d-none"
            dangerouslySetInnerHTML={{
              __html: displayText.replace(/\r\n/g, ''),
            }}
          />
          <div className="d-flex align-items-center justify-content-between mt-auto d-none">
            <a
              className="read-more-card mt-0 "
              onClick={() => handleNavigate(props.eventData.id)}
            >
              Read More
              <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
            </a>

            <a href="/event-details" className="theme-button par-btn my-0">
              Participate
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

CardItems.propTypes = {
  ImagesCard: PropTypes.node.isRequired,
  CardHeading: PropTypes.string,
  DateCard: PropTypes.string,
  CardText: PropTypes.string,
  HrefLink: PropTypes.string,
  eventData: PropTypes.object,
};

export default CardItems;
